"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerWrapper = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
function DatePickerWrapper({ children }) {
    const [open, setOpen] = (0, react_1.useState)(0);
    const cancelClickAway = (0, react_1.useRef)(false);
    const handleOpenDialog = (0, react_1.useCallback)(() => {
        setOpen(new Date().getTime());
    }, []);
    const handleCloseDialog = (0, react_1.useCallback)(() => {
        if (!open)
            return;
        if (new Date().getTime() - open > 500)
            setOpen(0);
    }, [open]);
    const handleClickAway = (0, react_1.useCallback)(() => {
        const cancel = cancelClickAway.current;
        cancelClickAway.current = false;
        if (!cancel)
            handleCloseDialog();
    }, [handleCloseDialog]);
    const handlePopperClick = (0, react_1.useCallback)(() => {
        cancelClickAway.current = true;
    }, []);
    const newChild = react_1.default.cloneElement(children, {
        open: !!open,
        onOpen: handleOpenDialog,
        onClose: handleCloseDialog,
        PopperProps: { onClick: handlePopperClick },
    });
    return react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: handleClickAway }, newChild);
}
exports.DatePickerWrapper = DatePickerWrapper;
exports.default = DatePickerWrapper;
